<template>
  <div class="part" v-loading="loading">
    <div id="title1">
      <childTitle v-loading="titleLoading" class="titleData" :titleData="titleData"></childTitle>
    </div>
    <div class="layout-page-box" id="title">
      <el-form :inline="true" label-position="right" class="search-form">
        <el-form-item label="院区">
          <el-select clearable v-model="filters.earId" placeholder="选择院区" multiple>
            <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初/复诊">
          <el-select clearable v-model="filters.status" placeholder="选择初/复诊" multiple>
            <el-option v-for="(item) in statusOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="划扣项目">
          <el-select ref='mySelected' @focus="focus(3)" clearable v-model="filters.musProjectNameId" placeholder="选择划扣项目"
            filterable :filter-method="projectMatch" multiple>
            <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买项目">
          <el-select @focus="focus(3)" clearable v-model="filters.projectId" placeholder="选择购买项目" filterable
            :filter-method="projectMatch" multiple>
            <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层">
          <el-select @focus="focus('lc')" clearable v-model="filters.sknFloor" placeholder="选择楼层" multiple>
            <el-option v-for="(item) in floorOptions" :key="item.id" :label="item.floorName" :value="item.floorName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门诊号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('cadCode')" @change.capture.native="onInput($event, 'cadCode')"
              :popper-append-to-body="false" clearable v-model="filters.cadCode" placeholder="请输入门诊号" multiple
              allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="耗材名称">
          <div class="no">
            <el-select @blur.capture.native="onBlur('materialName')"
              @change.capture.native="onInput($event, 'materialName')" :popper-append-to-body="false" clearable
              v-model="filters.materialName" placeholder="请输入耗材名称" multiple allow-create filterable
              default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="姓名">
          <div class="no">
            <el-select @blur.capture.native="onBlur('sknName')" @change.capture.native="onInput($event, 'sknName')"
              :popper-append-to-body="false" clearable v-model="filters.sknName" placeholder="请输入姓名" multiple filterable
              allow-create></el-select>
          </div>
        </el-form-item>
        <el-form-item label="手机号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('mobile')" @change.capture.native="onInput($event, 'mobile')"
              :popper-append-to-body="false" clearable v-model="filters.mobile" placeholder="请输入手机号" multiple allow-create
              filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="医生">
          <el-select allow-create @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable
            v-model="filters.doctorName" placeholder="选择医生" multiple>
            <el-option v-for="(item) in newList1" :key="item.identityName" :label="item.identityName"
              :value="item.identityName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="护士">
          <el-select allow-create @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable
            v-model="filters.nurseName" placeholder="选择护士" multiple>
            <el-option v-for="(item) in newList2" :key="item.identityName" :label="item.identityName"
              :value="item.identityName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医助">
          <el-select allow-create @focus="focus(4)" :filter-method="ccMatch" filterable remote clearable
            v-model="filters.aideName" placeholder="选择医助" multiple>
            <el-option v-for="(item) in newList4" :key="item.identityName" :label="item.identityName"
              :value="item.identityName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入人">
          <el-select @focus="focus(5)" :filter-method="ddMatch" filterable remote clearable v-model="filters.createBy"
            placeholder="选择录入人" multiple>
            <el-option v-for="(item) in manList" :key="item.id" :label="item.userName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否划扣">
          <el-select clearable v-model="filters.sknSign" placeholder="选择标记">
            <el-option v-for="(item) in flags" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="划扣时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="购买时间">
          <el-date-picker v-model="filters.purchaseStartTime" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <!-- <div class="delete" @click="del">删除</div> -->
        <!-- <div class="delete" @click="add">新增数据</div> -->
        <!-- <div class="addData" v-permission="'51'" @click="exp">导出业绩表(绩效部门)</div>
        <div class="addData" v-permission="'52'" @click="all">导出全年表</div>
        <div class="addData" v-permission="'53'" @click="skin">导出皮肤消费表</div>
        <div class="addData" v-permission="'54'" @click="reset">调整核算成本</div>
        <div class="addData" v-permission="'91'" @click="use">导出耗材使用情况</div> -->
        <!-- <div class="addData" v-permission="'16'" @click="edit">批量修改手机号</div>
        <div class="updatekc addData" v-permission="'6'">导入皮肤科消费表 <input class="filebox" type="file" name="file" ref="imgFile" v-on:change="handleFileChange" id='upFile'></div> -->
        <el-button type="warning" @click="add" icon="el-icon-plus">新增数据</el-button>
        <el-button type="success" v-permission="'51'" @click="exp" icon="el-icon-check">导出业绩表(绩效部门)</el-button>
        <el-button type="success" v-permission="'52'" @click="all" icon="el-icon-check">导出全年表</el-button>
        <el-button type="success" v-permission="'53'" @click="skin" icon="el-icon-check">导出皮肤消费表</el-button>
        <el-button type="success" v-permission="'91'" @click="use" icon="el-icon-check">导出耗材使用情况</el-button>
        <el-button type="success" v-permission="'91'" @click="use1" icon="el-icon-check">导出耗材使用汇总表</el-button>
        <el-button type="primary" v-permission="'54'" @click="reset" icon="el-icon-check">调整核算成本</el-button>
      </div>
    </div>
    <!--:height="tableHeight" -->
    <div class="layout-page-box" v-loading="tableload">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
        v-horizontal-scroll="'always'">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sknSign" label="是否划扣" width="80" fixed>
          <template slot-scope="scope">
            <el-switch v-model="scope.row.sknSign" active-color="#13ce66" inactive-color="#C9C9C9"
              @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="sknDate" label="日期" fixed width="100"></el-table-column>
        <el-table-column prop="sknName" label="姓名" fixed width="80"></el-table-column>
        <el-table-column prop="cadCode" label="门诊号" fixed width="120"></el-table-column>
        <el-table-column prop="status" label="初/复诊" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">初诊</span>
            <span v-if="scope.row.status == 2">复诊</span>
            <span v-if="scope.row.status == 3">再消费</span>
            <span v-if="scope.row.status == 4">复查</span>
            <span v-if="scope.row.status == 5">其他</span>
          </template>
        </el-table-column>
        <el-table-column prop="caseCode" label="病历号" width="110"></el-table-column>
        <el-table-column prop="flag" label="客户标签" width="50"></el-table-column>
        <!-- <el-table-column prop="sex" label="性别" width="35"></el-table-column>
        <el-table-column prop="age" label="年龄" width="45"></el-table-column> -->
        <el-table-column prop="mobile" label="电话" width="150">
          <template slot="header">
            <span>电话</span>
            <el-button style="margin-left:10px;" v-permission="'90'" @click="show" class="filter-item" type="success"
              size="mini" icon="el-icon-view"></el-button>
          </template>
          <template slot-scope="scope">
            <span v-if="mobileHiding == true">{{ scope.row.mobile }}</span>
            <span v-if="mobileHiding == false">
              <div v-for="(item, index) in scope.row.mobile.split('/')" :key='index'>
                {{ item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }}</div>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="informationSource" label="信息来源"></el-table-column> -->
        <el-table-column prop="projectName" label="购买项目" width="160">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.projectName != ' '">{{ item.projectName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="projectReplenish" label="项目补充" width="150">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.projectReplenish != ' '">{{ item.projectReplenish }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseTime" label="购买日期" width="100">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.purchaseTime != ' '">{{ item.purchaseTime }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseNumber" label="疗程购买次/支">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.purchaseNumber != ' '">{{ item.purchaseNumber }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="projectAmt" label="疗程收费">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.projectAmt != ' '">{{ item.projectAmt }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseRemark" label="购买备注">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.purchaseRemark != ' '">{{ item.purchaseRemark }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="musProjectName" label="当日划扣项目" width="170">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.musProjectName != ' '">{{ item.musProjectName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="musAmt" label="当日划扣金额">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.musAmt != ' '">{{ item.musAmt }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="musContent" label="划扣次数">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.musContent != ' '">{{ item.musContent }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="musCode" label="划扣卡号" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.list" :key="index">
              <span v-if="item.musCode!=' '">{{item.musCode}}</span>
              <span v-else style="opacity: 0;">{{'/'}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="instrumentName" label="仪器" width="120">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.instrumentName != ' '">{{ item.instrumentName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="musReplenish" label="划扣补充" width="150">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.musReplenish != ' '">{{ item.musReplenish }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="rnCount" label="剩余次数">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.list" :key="index">
              <span v-if="item.rnCount!=' '">{{item.rnCount}}</span>
              <span v-else style="opacity: 0;">{{'/'}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="remark" label="备注" width="120">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.remark != ' '">{{ item.remark }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="医生">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.doctorName != ' '">{{ item.doctorName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="aideName" label="医助">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.aideName != ' '">{{ item.aideName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="nurseName" label="护士">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.nurseName != ' '">{{ item.nurseName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" label="耗材名称" width="180">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.materialName != ' '">{{ item.materialName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="materialSpec" label="耗材规格" width="120">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.materialSpec != ' '">{{ item.materialSpec }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="manufacturers" label="耗材厂家">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.manufacturers != ' '">{{ item.manufacturers }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.number != ' '">{{ item.number }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="actualUse" label="实际使用">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.actualUse != ' '">{{ item.actualUse }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="empName" label="咨询师"></el-table-column>
        <!-- <el-table-column prop="projectRemark" label="产品备注"></el-table-column> -->
        <el-table-column prop="earName" label="院区" width="50"></el-table-column>
        <el-table-column prop="sknFloor" label="楼层" width="50"></el-table-column>
        <el-table-column prop="injectionProjectName" label="注射项目名称">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.injectionProjectName != ' '">{{ item.injectionProjectName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="injectionNurseName" label="送诊护士">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.list" :key="index">
              <span v-if="item.injectionNurseName != ' '">{{ item.injectionNurseName }}</span>
              <span v-else style="opacity: 0;">{{ '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="录入人" width="100"></el-table-column>
        <el-table-column prop="createTime" label="录入时间" width="100"></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.disabled" size="mini" type="primary"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button :disabled="scope.row.createBy == '' ? true : false" size="mini" type="danger"
              @click="del(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page"
        :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>

    <!-- 批量修改手机号 -->
    <el-dialog center title="批量修改手机号" :visible.sync="dialogForm">
      <phone @close="close" :multipleSelection="multipleSelection" @add-comment="appendComment" :form="form"></phone>
    </el-dialog>
    <!-- 新增和编辑弹框 -->
    <div class="all">
      <el-dialog center :visible.sync="dialog" v-if="dialog" :close-on-click-modal="false">
        <add ref="add" @close1="close1" @add-comment="appendComment" :formData="formData" :rowId='rowId'></add>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Add from './add.vue';
import childTitle from './title.vue';
import phone from './phone.vue';
import permission from '../../directives/permission/index'
import { v4 as uuidv4 } from "uuid";
import { log } from 'util';
export default {
  directives: {
    permission
  },
  name: "instrument",
  components: { phone, Add, childTitle },
  computed: {
    ...mapState(['statusOptions', 'areaOptions']),
    ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'createByList', 'areaAndFloorList']),
  },
  data() {
    return {
      formData: {},
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: [_g.getMonths()[0], _g.getMonths()[1]],
        endTime: '',
        purchaseStartTime: '',
        purchaseEndTime: "",
        musProjectName: [],
        project: [],
      },
      tableData: [],
      multipleSelection: [],
      loading: false,
      dialogForm: false,
      form: {},
      dialog: false,
      newList1: [],
      newList2: [],
      newList4: [],
      empty: [],
      projectList: [],
      manList: [],
      floorOptions: [],
      rowId: '',
      tableload: false,
      inputName: '',
      inputCode: "",
      inputmater: "",
      inputMobile: "",
      jurisdictionId: Lockr.get("skinJurisdictionId"),
      empId: Lockr.get("skinEmpId"),
      s: [],
      titleData: {
        musProjectOld: 0,
        projectAmtOld: 0,
        musAmt: 0,
        musAmtOld: 0,
        musProject: 0,
        client: 0,
        clientOld: 0,
        projectAmt: 0,
        project: 0,
        projectOld: 0,
        musClient: 0,
        musClientOld: 0,
        musTime: 0,
        purchaseTime: 0,
        aa: 0,
        bb: 0,
      },
      tableHeight: 0,
      num: 0,
      flags: [
        {
          name: '已标记',
          id: 1
        },
        {
          name: '未标记',
          id: 0
        },
      ],
      mobileHiding: false,
      titleLoading: false,
    }
  },
  methods: {
    show() {
      this.mobileHiding = !this.mobileHiding
    },
    change(index, row) {
      let data = {
        id: row.id,
        createdBy: this.empId,
        // 0：正常 1：禁用
      }
      api.request("/skn/updateSknMaterialSknSign", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "标记操作成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "标记操作失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
    // 获取时间差
    getIntervalHour(dt1, dt2) {
      if (typeof (dt1) == "string") {
        dt1 = new Date(dt1.replace(/-/, '/'));
        dt2 = new Date(dt2.replace(/-/, '/'));
      }
      var res = dt2 - dt1;
      if (isNaN(res))
        throw Error("invalid dates arguments");
      return res / (1000 * 60 * 60);
    },
    // 上传文件
    handleFileChange() {
      var that = this;
      var file = document.getElementById("upFile").files[0]; //获取文件
      var formData = new FormData();
      formData.append("file", file)
      api.request("skn/importSknMaterial", formData, (res) => {
        if (res.result == true) {
          var test = document.getElementById('upFile');
          test.value = ''; 					//虽然test的value不能设为有字符的值，但是可以设置为空值
          _g.toast('success', '导入成功!')
          this.query()
        } else {
          var test = document.getElementById('upFile');
          test.value = ''; 					//虽然test的value不能设为有字符的值，但是可以设置为空值
          _g.toast('error', '导入失败!')
          this.query()
        }
      })

    },
    getArr(arr) {
      // 获取每一项下的楼层数组
      let time = arr.map(val => {
        return val.floorNameList
      })
      // 二维数组转一维数组
      let newArr = time.flat();
      // 数组去重
      let obj = {};
      newArr = newArr.reduce((cur, next) => {
        obj[next.floorName] ? "" : obj[next.floorName] = true && cur.push(next);
        return cur;
      }, [])
      return newArr
    },
    focus(val) {
      if (val == 1) {
        this.newList1 = this.list1
      } else if (val == 2) {
        this.newList2 = this.list2
      } else if (val == 4) {
        this.newList4 = this.list4
      } else if (val == 3) {
        this.projectList = this.productOptions
      } else if (val == 5) {
        this.manList = this.createByList
      } else if (val == 'lc') {
        let newArr = this.getArr(this.areaAndFloorList)
        // 给楼层对象赋值
        this.floorOptions = newArr
      }
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
          random: Math.random()
        })
      })
    },
    // 新增仪器
    add() {
      this.dialog = true
      this.rowId = ''
      // router.push({ path: '/instrument/add' })
      this.formData = {
        sknDate: '',
        name: '',
        earName: '',
        sknFloor: "",
        mobile: '',
        status: "",
        caseCode: "",
        flag: "",
        informationSource: '',
        information: 1,
        sex: '',
        earId: '',
        age: "",
        empName: '',
        cadCode: '',
        purchaseInformationList: [{
          projectId: "",
          project: "",
          projectName: '',
          purchaseNumber: '',
          projectAmt: '',
          projectType: '1',
          projectReplenish: "",
          purchaseRemark: '',
          isFlag: false,
          purchaseId: uuidv4(),
          isCreate: false,
          createTime: '',
        }],
        purchaseInformationDtoList: [],
        refundInformationList: [],
        musInformationList: [],
        injectionProjectList: [{
          injectionProjectName: '',
          injectionProjectAmt: '',
          injectionNurseName: '',
        }],
      }
    },
    handleEdit(index, row) {
      this.dialog = true
      this.rowId = row.id
      api.request("/skn/findSknMaterialById", { id: row.id }, (res) => {
        this.formData = res.data
        this.formData.musInformationList.forEach((item) => {
          item.doctorNo = Number(item.doctorNo)
          item.nurseNo = Number(item.nurseNo)
          item.aideNo = Number(item.aideNo)
        });
        this.formData.musInformationList.forEach(ele => {
          ele.unitPrice = parseFloat(ele.projectAmt) / parseFloat(ele.purchaseNumber)//项目单价
        });
        if (this.formData.refundInformationList) {
          this.formData.refundInformationList.forEach(ele => {
            ele.unitPrice = parseFloat(ele.projectAmt) / parseFloat(ele.purchaseNumber)//项目单价
          });
        } else {
          this.$set(this.formData, 'refundInformationList', [])
        }
        this.$refs.add.getProject(1, this.formData.mobile.replace(/\//g, "/"), this.rowId);
      }, (err) => { })
    },
    getquerys(page) {
      this.filters.musProjectName = []
      this.filters.project = []
      this.projectList.forEach(item => {
        // 获取划扣项目选中的名称
        this.filters.musProjectNameId.forEach(ele => {
          if (ele == item.id) {
            this.filters.musProjectName.push(item.project)
          }
        });
        // 获取选中购买项目名称的name
        this.filters.projectId.forEach(val => {
          if (val == item.id) {
            this.filters.project.push(item.project)
          }
        });
      });
      var querys = {
        earId: this.filters.earId.toString(),
        status: this.filters.status.toString(),
        cadCode: this.filters.cadCode.toString(),
        sknFloor: this.filters.sknFloor.toString(),
        mobile: this.filters.mobile.toString(),
        createBy: this.filters.createBy.toString(),
        musProjectNameId: this.filters.musProjectNameId.toString(),
        musProjectName: this.filters.musProjectName.toString(),
        projectId: this.filters.projectId.toString(),
        project: this.filters.project.toString(),
        doctorName: this.filters.doctorName.toString(),
        nurseName: this.filters.nurseName.toString(),
        aideName: this.filters.aideName.toString(),
        materialName: this.filters.materialName.toString(),
        sknName: this.filters.sknName.toString(),
        page: page,
        size: this.filters.pagination.limit,
        startTime: '',
        endTime: '',
        purchaseStartTime: '',
        purchaseEndTime: "",
        sknSign: this.filters.sknSign
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      if (this.filters.purchaseStartTime) {
        querys.purchaseStartTime = this.filters.purchaseStartTime[0]
        querys.purchaseEndTime = this.filters.purchaseStartTime[1]
      }
      return querys
    },
    // 查询数据列表
    query(page) {
      this.tableload = true
      this.titleLoading = true
      let querys = this.getquerys(page)
      console.log(querys)
      api.request('/skn/findSknMaterialList', querys, (res) => {
        // console.log(res)
        if (res.result == true) {
          var data = res.data.list
          this.tableData = data
          this.filters.pagination.total = parseInt(res.data.count)
          this.tableload = false
          this.tableData.forEach(ele => {
            // ele.hour = this.getIntervalHour(ele.createTime, _g.transformTime())
            // 判断编辑权限、超过48小时无法编辑、管理员可以修改导入的历史数据
            if (this.jurisdictionId != 1) {
              if (ele.createBy == '') {
                ele.disabled = true
              } else {
                ele.disabled = false
                // if (ele.hour >= 240) {
                //   ele.disabled = true
                // } else {
                //   ele.disabled = false
                // }
              }
            }
            let reg = new RegExp('，', 'g')//g代表全部
            ele.mobile = (ele.mobile).replace(reg, '/');
          });

          api.request('/skn/findSknMaterialStatistic', querys, (res) => {
            if (res.data.length) {
              console.log('0000');
              this.titleData = res.data[0]
              this.titleData.aa = (this.titleData.musAmt + this.titleData.musAmtOld).toFixed(2)
              this.titleData.bb = (this.titleData.projectAmt + this.titleData.projectAmtOld).toFixed(2)
              this.titleLoading = false
            } else if (!res.data.length) {
              console.log('999');
              this.titleData = res.data
              this.titleLoading = false
            }
          }, (err) => { this.titleLoading = false })
        }
      }, (err) => { })
    },
    // 导出皮肤科消费列表
    skin() {
      this.common("skn/excelSknMaterialList", "皮肤科消费列表.xlsx", false)
    },
    // 调整核算成本
    reset() {
      this.common("skn/excelSknMaterialList", "调整核算成本列表.xlsx", true)
    },
    // 导出每日耗材使用情况
    use() {
      this.common("skn/excelSknMaterialStatistic", "皮肤科耗材使用情况表.xlsx", true)
    },
    //导出耗材使用汇总表
    use1() {
      this.common("skn/excelSknProjectMaterialStatisticSummaryTable", "皮肤科导出耗材使用汇总表.xlsx", true)
    },
    // 导出业绩表
    exp() {
      this.common("skn/excelSknPerformanceList", "皮肤科业绩表.xlsx", '')
    },
    // 导出全年表
    all() {
      this.common("skn/excelSknAnnualList", "皮肤科全年表.xlsx", '')
    },
    common(commonUrl, title, adjust) {
      console.log('导出时电话状态是否隐藏');
      console.log(this.mobileHiding);
      let exportUrl = axios.defaults.baseURL;
      this.filters.musProjectName = []
      this.filters.project = []
      this.projectList.forEach(item => {
        // 获取划扣项目选中的名称
        this.filters.musProjectNameId.forEach(ele => {
          if (ele == item.id) {
            this.filters.musProjectName.push(item.project)
          }
        });
        // 获取选中购买项目名称的name
        this.filters.projectId.forEach(val => {
          if (val == item.id) {
            this.filters.project.push(item.project)
          }
        });
      });
      var register = {
        total: this.filters.pagination.total,
        startTime: '',
        endTime: "",
        purchaseStartTime: '',
        purchaseEndTime: "",
        earId: this.filters.earId.toString(),//院区
        status: this.filters.status.toString(),//分诊状态
        cadCode: this.filters.cadCode.toString(),//客户卡号（门诊号）
        sknFloor: this.filters.sknFloor.toString(),//楼层
        mobile: this.filters.mobile.toString(),//电话
        createBy: this.filters.createBy.toString(),//创建人
        musProjectNameId: this.filters.musProjectNameId.toString(),//划扣项目
        musProjectName: this.filters.musProjectName.toString(),
        projectId: this.filters.projectId.toString(),//购买项目
        project: this.filters.project.toString(),
        doctorName: this.filters.doctorName.toString(),//医生
        nurseName: this.filters.nurseName.toString(),//护士aideName
        aideName: this.filters.aideName.toString(),//护士
        materialName: this.filters.materialName.toString(),//耗材
        sknName: this.filters.sknName.toString(),//姓名
        adjust: adjust,//调整核算成本
        createById: this.empId,
        sknSign: this.filters.sknSign,
        mobileHiding: this.mobileHiding
      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      if (this.filters.purchaseStartTime) {
        register.purchaseStartTime = this.filters.purchaseStartTime[0]
        register.purchaseEndTime = this.filters.purchaseStartTime[1]
      }
      var formData = new FormData();
      formData.append("information", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + commonUrl, formData, {
              responseType: "blob",
            }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = title;
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 删除项目
    del(row, index) {
      this.$confirm('确定要该条数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/skn/deleteSknMaterialById", {
            id: row.id,
            createBy: this.empId,
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })
    },
    edit() {
      if (this.multipleSelection.length == 0) {
        _g.toast("warning", "请先选择要修改的数据")
      } else {
        this.form = {
          mobile: "",
          sknMaterialId: "",
        }
        this.dialogForm = true
      }
    },
    close() {
      this.dialogForm = false
    },
    close1() {
      this.dialog = false
    },
    appendComment(item) {
      this.query(this.filters.pagination.page);
    },
    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
    },
    bbMatch(val) {
      this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
    },
    ccMatch(val) {
      this.newList4 = _g.paramMatch(this.list4, this.newList4, val, 'identityName')
    },
    projectMatch(val) {
      this.projectList = _g.paramMatch(this.productOptions, this.projectList, val, 'project')
    },
    ddMatch(val) {
      this.manList = _g.paramMatch(this.createByList, this.manList, val, 'userName')
    },
    // 姓名多选款
    onBlur(val) {
      if (val == 'sknName') {
        if (this.inputName != '' && !this.filters.sknName.includes(this.inputName)) {
          this.filters.sknName.push(this.inputName)
          this.inputName = ''
        }
      } else if (val == 'materialName') {
        if (this.inputmater != '' && !this.filters.materialName.includes(this.inputmater)) {
          this.filters.materialName.push(this.inputmater)
          this.inputmater = ''
        }
      } else if (val == 'cadCode') {
        if (this.inputCode != '' && !this.filters.cadCode.includes(this.inputCode)) {
          this.filters.cadCode.push(this.inputCode)
          this.inputCode = ''
        }
      } else if (val == 'mobile' && !this.filters.mobile.includes(this.inputMobile)) {
        if (this.inputMobile != '') {
          this.filters.mobile.push(this.inputMobile)
          this.inputMobile = ''
        }
      }
    },
    onInput(index, val) {
      if (index.target.value != '') {
        if (val == 'sknName') {
          this.inputName = index.target.value
        } else if (val == 'materialName') {
          this.inputmater = index.target.value
        } else if (val == 'cadCode') {
          this.inputCode = index.target.value
        } else if (val == 'mobile') {
          this.inputMobile = index.target.value
        }
      }
    },
    getMonths() {
      var now = new Date(); //当前日期
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getFullYear(); //当前年
      //本月的开始时间
      var monthStartDate = _g.transformTime(new Date(nowYear, nowMonth, 1));
      //本月的结束时间
      var monthEndDate = _g.transformTime(new Date(nowYear, nowMonth + 1, 0));
      return [monthStartDate, monthEndDate]
    },
  },
  mounted() {
    this.$store.dispatch('getIdList')
    this.query(this.filters.pagination.page)
  },
  created() {
    // this.$nextTick(() => {
    //   // title查询条件div的高度
    //   let aa = document.getElementById("title1").scrollHeight + 70
    //   this.num = document.getElementById("title").scrollHeight + aa
    //   // content内容的高度 = 页面可见高度 - title查询条件的高度-分页样式的高度
    //   this.tableHeight = document.documentElement.clientHeight - this.num - 30
    // });
  },
  watch: {
    '$route'(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.part>>>.el-table .el-table__cell {
  padding: 0 !important;
  box-sizing: border-box;
}

.all>>>.el-dialog {
  width: 90% !important;
}

.all>>>.el-dialog__body {
  padding: 0px 30px;
  box-sizing: border-box;
}

.all>>>.el-dialog__header {
  padding-top: 0px !important;
}

.no>>>.el-select-dropdown {
  display: none;
}

.filebox {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  left: 0;
  top: 0;
}

.updatekc {
  position: relative;
  cursor: pointer;
}

.el-table>>>.warm-row {
  background: #f5f1a6;
}

.part>>>.el-button i {
  margin-right: 0px !important;
}

/* .part >>> .el-table .cell {
  text-align: center;
} */
</style>